import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  homeContainer: {
    marginTop: '2rem',
    padding: '2rem',
  },
}))
